// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle box shadow */
  margin-top: 10px;
}

form {
  display: flex;
  flex-direction: column;
}

label {
  font-weight: 600;
  color: #333;
}

input {
  width: calc(100% - 24px);
  padding: 12px;
  margin-bottom: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: border-color 0.3s ease-in-out;
}

input:focus {
  outline: none;
  border-color: #3498db;
}

.submit-button {
  width: 97%;
  padding: 14px 20px;
  background-color: #3498db;
  color: #fff;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  margin-top: 100px;
}

.submit-button:hover {
  background-color: #207ebf;
  margin-top: 20px;
}

/* Optional: Add spacing to the body */
body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  margin: 20px;
}

/* Optional: Set a global box-sizing property for better layout control */
* {
  box-sizing: border-box;
}

.scroller-container {
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 30px;
  margin-top: 10px;
}

.contact-title {
	text-align: left;
	margin-bottom: 20px;
}

.agreement-checkbox {
  display: grid;
  grid-auto-flow: column;
  align-items: center;
}

.agreement-checkbox input[type="checkbox"] {
  margin-left: -200px;
  margin-bottom: 30px;
}

.checkbox-text {
	margin-left: -400px;
	margin-bottom: 30px;
}

.agreement-checkbox label {
  	#text-align: left;
	#display: inline-block;
}


.emoji-btn {
  font-size: 1em;
  background-color: #3498db;
  color: #fff;
  border: none;
  border-radius: 5px;
  margin: 5px;
  padding: 3px 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.description-container {
	text-align: left;
	justify: center;
	margin-bottom: 30px;
	width: 100%;
      	max-height: 300px;
      	overflow-y: auto;
      	border: 1px solid #ccc;
      	padding: 10px;
      	margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/Contact.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC,EAAE,sBAAsB;EAChE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,YAAY;AACd;;AAEA,yEAAyE;AACzE;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;GACG,iBAAiB;CACnB,sBAAsB;AACvB;;;AAGA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,WAAW;OACL,iBAAiB;OACjB,gBAAgB;OAChB,sBAAsB;OACtB,aAAa;OACb,gBAAgB;AACvB","sourcesContent":[".contact-page-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f7f7f7;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle box shadow */\n  margin-top: 10px;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n}\n\nlabel {\n  font-weight: 600;\n  color: #333;\n}\n\ninput {\n  width: calc(100% - 24px);\n  padding: 12px;\n  margin-bottom: 16px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  transition: border-color 0.3s ease-in-out;\n}\n\ninput:focus {\n  outline: none;\n  border-color: #3498db;\n}\n\n.submit-button {\n  width: 97%;\n  padding: 14px 20px;\n  background-color: #3498db;\n  color: #fff;\n  border: none;\n  border-radius: 7px;\n  cursor: pointer;\n  transition: background-color 0.3s ease-in-out;\n  margin-top: 100px;\n}\n\n.submit-button:hover {\n  background-color: #207ebf;\n  margin-top: 20px;\n}\n\n/* Optional: Add spacing to the body */\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.6;\n  margin: 20px;\n}\n\n/* Optional: Set a global box-sizing property for better layout control */\n* {\n  box-sizing: border-box;\n}\n\n.scroller-container {\n  width: 100%;\n  max-height: 300px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  padding: 10px;\n  margin-bottom: 30px;\n  margin-top: 10px;\n}\n\n.contact-title {\n\ttext-align: left;\n\tmargin-bottom: 20px;\n}\n\n.agreement-checkbox {\n  display: grid;\n  grid-auto-flow: column;\n  align-items: center;\n}\n\n.agreement-checkbox input[type=\"checkbox\"] {\n  margin-left: -200px;\n  margin-bottom: 30px;\n}\n\n.checkbox-text {\n\tmargin-left: -400px;\n\tmargin-bottom: 30px;\n}\n\n.agreement-checkbox label {\n  \t#text-align: left;\n\t#display: inline-block;\n}\n\n\n.emoji-btn {\n  font-size: 1em;\n  background-color: #3498db;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  margin: 5px;\n  padding: 3px 20px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.description-container {\n\ttext-align: left;\n\tjustify: center;\n\tmargin-bottom: 30px;\n\twidth: 100%;\n      \tmax-height: 300px;\n      \toverflow-y: auto;\n      \tborder: 1px solid #ccc;\n      \tpadding: 10px;\n      \tmargin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
